// fileIconHelper.js
import React from "react";
import {
  FaFileAlt,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileImage,
  FaFileVideo,
  FaFileAudio,
  FaFileArchive,
  FaFileCode,
  FaFolder
} from "react-icons/fa";

export const getFileIcon = (fileName, size = 32) => {
  const ext = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();

  switch (ext) {
    case ".pdf":
      return <FaFilePdf size={size} className="text-red-500" />;
    case ".doc":
    case ".docx":
      return <FaFileWord size={size} className="text-blue-500" />;
    case ".xls":
    case ".xlsx":
      return <FaFileExcel size={size} className="text-green-500" />;
    case ".ppt":
    case ".pptx":
      return <FaFilePowerpoint size={size} className="text-orange-500" />;
    case ".png":
    case ".jpg":
    case ".jpeg":
    case ".gif":
    case ".bmp":
    case ".webp":
      return <FaFileImage size={size} className="text-purple-500" />;
    case ".mp4":
    case ".mov":
    case ".avi":
    case ".mkv":
      return <FaFileVideo size={size} className="text-yellow-500" />;
    case ".mp3":
    case ".wav":
    case ".ogg":
      return <FaFileAudio size={size} className="text-pink-500" />;
    case ".zip":
    case ".rar":
    case ".7z":
    case ".tar":
    case ".gz":
      return <FaFileArchive size={size} className="text-orange-600" />;
    case ".txt":
      return <FaFileAlt size={size} className="text-gray-500" />;
    case ".js":
    case ".jsx":
    case ".html":
    case ".css":
    case ".json":
    case ".ts":
    case ".tsx":
      return <FaFileCode size={size} className="text-indigo-500" />;
    default:
      return <FaFileAlt size={size} className="text-gray-500" />;
  }
};

export const getFolderIcon = (size = 32) => {
  // You might want to import a specific folder icon from react-icons if you have one.
  // Here we use FaFileAlt as a placeholder; you can replace it with a folder icon.
  // For example, you might use FaFolder from "react-icons/fa".
  return <FaFolder size={size} className="text-blue-600" />;
};